// extracted by mini-css-extract-plugin
export var iframe = "i+xEBSAQ";